<template>
  <div class="china" ref="chart"></div>
</template>

<script>
import chinaJson from '@/assets/joins/china.json'

export default {
  props: {
    classifyId: [Number, String]
  },
  watch: {
    classifyId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.init(val)
          })
        }
      }
    }
  },
  methods: {
    /**
     * 初始化
     */
    init(classifyId) {
      const that = this
      that.$echarts.registerMap('china', chinaJson)
      let chart = that.$echarts.init(this.$refs.chart)

      that.$request.get('/Joins/city', {
        params: {
          classifyId
        }
      }).then(res => {
        if (res.code === 0) {
          let options = {
            geo: {
              type: 'map',
              map: 'china',
              roam: false,
              zoom: 1.252,
              center: [104.1, 28.4],
              itemStyle: {
                areaColor: '#CDE2FA',
                borderColor: '#3c86c8'
              }
            },
            series: [
              {
                type: 'effectScatter',
                coordinateSystem: 'geo',
                data: res.data,
                symbolSize: 5,
                showEffectOn: 'render',
                rippleEffect: {
                  brushType: 'stroke',
                  color: '#f13434',
                  period: 4,
                  scale: 6
                },
                emphasis: {
                  scale: false
                },
                label: {
                  formatter: '{b}',
                  position: 'top',
                  show: true,
                  fontSize: 10
                },
                itemStyle: {
                  color: '#f13434',
                  shadowBlur: 2,
                  shadowColor: '#333'
                },
                zlevel: 1
              }
            ]
          }
          chart.setOption(options)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.china {
  width: 1100px;
  height: 1200px;
}
</style>